import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Instagram, Twitter, Linkedin } from 'lucide-react';
import { siteContent } from '../data/content';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          
          {/* About Section */}
          <div>
            {/* Logo */}
            <img
              src={process.env.PUBLIC_URL + "/images/logo2.png"}
              alt="Surya Diagnostic Center Logo"
             className="h-20 md:h-32 w-auto mb-4"
            />

            <h3 className="text-xl font-bold mb-4">Surya Diagnostic Center</h3>
            <p className="text-gray-400 mb-4">उच्च तंत्रज्ञान | अनुभवी डॉक्टर | अचूक निदान</p>
            <p className="text-gray-400 mb-4">
              Leading diagnostic center providing world-class medical imaging and laboratory services with precision and care.
            </p>

            <div className="flex gap-3">
              <a
                href="https://www.facebook.com/people/Surya-Diagnostics/100073598557899/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-green-800 rounded-full flex items-center justify-center hover:bg-green-700 transition-colors"
                data-testid="footer-facebook"
              >
                <Facebook size={18} />
              </a>

              <a
                href="https://www.instagram.com/surya_diagnostics1/?igshid=MzRlODBiNWFlZA%3D%3D"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-green-800 rounded-full flex items-center justify-center hover:bg-green-700 transition-colors"
                data-testid="footer-instagram"
              >
                <Instagram size={18} />
              </a>

              <a
                href="#"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-green-800 rounded-full flex items-center justify-center hover:bg-green-700 transition-colors"
                data-testid="footer-twitter"
              >
                <Twitter size={18} />
              </a>

              <a
                href="#"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-green-800 rounded-full flex items-center justify-center hover:bg-green-700 transition-colors"
                data-testid="footer-linkedin"
              >
                <Linkedin size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-400 hover:text-green-400 transition-colors">Home</Link></li>
              <li><Link to="/about" className="text-gray-400 hover:text-green-400 transition-colors">About Us</Link></li>
              <li><Link to="/services" className="text-gray-400 hover:text-green-400 transition-colors">Services</Link></li>
              <li><Link to="/health-packages" className="text-gray-400 hover:text-green-400 transition-colors">Health Packages</Link></li>
               <li><Link to="/gallery" className="text-gray-400 hover:text-green-400 transition-colors">Gallery</Link></li> 

              <li><Link to="/blogs" className="text-gray-400 hover:text-green-400 transition-colors">Blogs</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-xl font-bold mb-4">Our Services</h3>
            <ul className="space-y-2">
              {siteContent.services.slice(0, 6).map((service) => (
                <li key={service.id}>
                  <Link
                    to={`/services/${service.id}`}
                    className="text-gray-400 hover:text-green-400 transition-colors"
                  >
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-bold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
  <MapPin size={20} className="text-green-400 flex-shrink-0 mt-1" />
  <a
    href="https://share.google/hLm2MrsmjeliLjLwv"
    target="_blank"
    rel="noopener noreferrer"
    className="text-gray-400 hover:text-green-400 transition-colors"
  >
    {siteContent.branding.address}
  </a>
</li>
            <li className="flex items-start gap-3">
  <Phone size={20} className="text-green-400 flex-shrink-0 mt-1" />

  <div className="flex flex-col gap-1">
    {siteContent.branding.phones.map((phone, index) => (
      <a
        key={index}
        href={`tel:${phone}`}
        className="text-gray-400 hover:text-green-400 transition-colors"
      >
        {phone}
      </a>
    ))}
  </div>
</li>
              <li className="flex items-center gap-3">
                <Mail size={20} className="text-green-400 flex-shrink-0" />
                <a
                  href={`mailto:${siteContent.branding.email}`}
                  className="text-gray-400 hover:text-green-400 transition-colors"
                >
                  {siteContent.branding.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} Surya Diagnostic Center. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm">
            <Link to="/" className="text-gray-400 hover:text-green-400 transition-colors">Privacy Policy</Link>
            <Link to="/" className="text-gray-400 hover:text-green-400 transition-colors">Terms of Service</Link>
            <Link to="/faqs" className="text-gray-400 hover:text-green-400 transition-colors">FAQs</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
